module.exports = __webpack_public_path__ + "img/e0a8059.png";